import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import Vant from "vant";
import MetaInfo from "vue-meta-info";

// import "./plugins/vueamap.js"; //  vue-amap 高德地图
import "./plugins/element.js"; //  elemnt组件
import { post, get, downFile, put, deletes, toJson, isEmpty } from "./plugins/http.js"; // 请求方式中间件
import { api } from "./plugins/api.js"; // API 链接
import { option } from "./plugins/options.js"; // API 链接
import { formatDate, formatGoods, getQueryData, setNavigationTitle, formatKeyValue } from "./plugins/function.js"; // 公共方法
import "../public/fonts/iconfont.css"; // 阿里图标
import "../public/icon/iconfont.css"; // 阿里图标
import "vant/lib/index.css";
import "../public/style.css"; // 公共CSS
Vue.use(MetaInfo);
Vue.use(Vant);

import skeleton from "vue-skeleton-component"; // 骨架

import md5 from "js-md5"; // md5
// import store from './store' // VUEX

//定义全局变量
Vue.prototype.$api = api;
Vue.prototype.$option = option;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$downFile = downFile;
Vue.prototype.$put = put;
Vue.prototype.$delete = deletes;
Vue.prototype.$toJson = toJson;
Vue.prototype.$isEmpty = isEmpty;
Vue.prototype.$formatDate = formatDate;
Vue.prototype.$md5 = md5;
Vue.prototype.$formatGoods = formatGoods;
Vue.prototype.$getQueryData = getQueryData;
Vue.prototype.$formatKeyValue = formatKeyValue;
Vue.prototype.$setNavigationTitle = setNavigationTitle;

// 时间格式化
Vue.filter("formatDate", function(time) {
  var date = new Date(time * 1000);
  return formatDate(date, "yyyy-MM-dd hh:mm:ss");
});

Vue.filter("formatDateAuto", function(time, str) {
  var date = new Date(time * 1000);
  return formatDate(date, str);
});

Vue.filter("formFlisUrl", function(url) {
  let arr = url.split("/");
  let filename = arr[arr.length - 1];
  return filename;
});

Vue.config.productionTip = false;

Vue.use(skeleton); // 骨架

new Vue({
  router,
  // store,
  render: (h) => h(App),
  // mounted() {
  //   this.$on('error', (err, vm, info) => {
  //     console.log(456879);
  //     const errorDiv = document.createElement('div');
  //     errorDiv.style.position = 'fixed';
  //     errorDiv.style.backgroundColor = 'red';
  //     errorDiv.style.color = 'white';
  //     errorDiv.style.top = '5px';
  //     errorDiv.textContent = `Error: ${err.toString()}`;
  //     document.body.appendChild(errorDiv);
  //   });
  // }
}).$mount("#app");




// window.onerror = function(message, source, lineno, colno, error) {
//   console.log(456879);
//   console.error('Global Error:', message, source, lineno, colno, error);
//   const errorDiv = document.createElement('div');
//   errorDiv.style.position = 'fixed';
//   errorDiv.style.backgroundColor = 'red';
//   errorDiv.style.color = 'white';
//   errorDiv.style.top = '5px';
//   errorDiv.textContent = `Error: ${error.toString()}`;
//   document.body.appendChild(errorDiv);
// };

